<app-header></app-header>

<div class="content-wrapper my-5 p-t-25 dis-flex">
  <div *ngIf="isSidebarOpen" class="sidebar">
    <app-sidebar
      (progressDashboardSelection)="onProgressDashboard($event)"
      [isDashboard]="true"
      [quarter]="quarter"
      [progressDashboardListParentGroup]="progressDashboardListParentGroup"
      [selectProgressDashSubGroupsData]="selectProgressDashSubGroupsData"
      [progressDashTeamMembers]="progressDashTeamMembers"
      [type]="this.types"
      (onProgressTeamMemeber)="onProgressTeamMemeber($event)"
      (close)="toggleSidebar()"
    ></app-sidebar>
  </div>
  <div class="main-content p-t-20">
    <div class="container-fluid">
      <div>
        <p-breadcrumb
          class="max-w-full"
          [model]="breadCrumbItems"
          [home]="breadCrumbHome"
        >
          <ng-template pTemplate="item" let-item>
            <p class="b2 m-b-0">{{ item.label }}</p>
          </ng-template>
          <ng-template pTemplate="separator"> / </ng-template>
        </p-breadcrumb>
      </div>
      <div class="dis-flex flex-m flex-sb">
        <div class="dis-flex flex-m">
          <h1 class="font-medium m-b-0">Progress Dashboard</h1>
          <div
            class="dependency-type radius-8 border-20 bg-white p-t-4 p-b-4 p-r-4 p-l-4 m-l-20"
          >
            <p-selectButton
              [options]="viewOptions"
              [(ngModel)]="val"
              optionValue="val"
              (ngModelChange)="onChangeViewType(val)"
            >
              <ng-template let-item pTemplate>
                <ng-icon class="lh-1-0" [name]="item.icon" size="20" />
              </ng-template>
            </p-selectButton>
          </div>
        </div>
        <div class="dis-flex">
          <div class="search-box-wrapper m-r-20" *ngIf="val != 'chartView'">
            <ng-icon
              name="hugeSearch01"
              size="16"
              class="m-r-5 lh-1-0 text-70"
            ></ng-icon>
            <input
              class="radius-8 b2"
              type="text"
              pInputText
              placeholder="Search"
              [(ngModel)]="searchQuery"
              (input)="onSearchInput()"
            />
          </div>
          <button
            class="btn outline b2 wd-120px m-r-20"
            (click)="toggleSidebar()"
            *ngIf="val != 'chartView'"
          >
            <ng-icon
              name="hugeFilter"
              size="16"
              class="m-r-5 lh-1-0 text-70"
            ></ng-icon>
            Filters {{ filterCount > 0 ? "(" + filterCount + ")" : "" }}
          </button>
            <p class="item-title text-left m-b-0 b2 font-medium text-80">
            </p>
            <p-dropdown *ngIf="val == 'chartView'"
              class="m-r-10"
              id="dropdown"
              [options]="outcomeYear"
              placeholder="Select Year"
              [(ngModel)]="sidebarService.selectedChartProgressDashboardYear"
              filterPlaceholder="Search"
              [showClear]="false"
              optionLabel="value"
              (onChange)="onProgressDashboardYearChange($event)"
              [overlayOptions]="helper.getOverlayOptions()"
            >
            </p-dropdown>
          <div
            class="dependency-type radius-8 border-20 bg-white p-t-4 p-b-4 p-r-4 p-l-4"
          >
            <p-selectButton
              [options]="outcomeType"
              [(ngModel)]="value"
              optionLabel="label"
              optionValue="value"
              (ngModelChange)="onValueChange(value)"
            />
          </div>
        </div>
      </div>

      <div class="body-card">
        <div class="progress-view w-full">
          <div *ngIf="value == 'quarterly'">
            <div class="graph-view" *ngIf="val == 'chartView'">
              <div class="dis-flex">
                <div class="graph-card">
                  <h3
                    class="graph-title text-90 font-medium border-bottom-20 p-b-8" ngbTooltip="Short Term Outcomes"
                  >
                    STO (Type of Work)
                  </h3>
                  <div class="graph-wrapper">
                    <div *ngIf="!isTypedLoading;else ShimmerEffect">
                    <ng-container *ngIf="!NoCountShowType;else noDataFound">
                    <app-polar
                      *ngIf="!QTypeOfWork"
                      class="m-t-23"
                      [customLabels]="[
                        'Ad-Hoc',
                        'Foundational',
                        'Work Package'
                      ]"
                      [customSeries]="graphtypes"
                    ></app-polar>

                  </ng-container>
                </div>
                  </div>
                </div>
                <div class="graph-card">
                  <h3
                    class="graph-title text-90 font-medium border-bottom-20 p-b-8" ngbTooltip="Short Term Outcomes"
                  >
                    STO (Status Wise)
                  </h3>
                  <div class="graph-wrapper">
                    <!-- <div *ngIf="QStatusWise">Loading status wise data...</div> -->
                   <ng-container *ngIf="!NoCountShow;else noDataFound">
                    <app-doughnut
                    *ngIf="!QStatusWise"
                    class="m-t-23"
                    [colors]="[
                      '#544F4F',
                      '#FFAA00',
                      '#00B458',
                      '#FF1F26',
                      '#8C0000'
                    ]"
                    [customLabels]="[
                      'Not Started',
                      'Ongoing',
                      'Completed',
                      'Delayed',
                      'Terminated'
                    ]"
                    [series]="graphstatus"
                  ></app-doughnut>
                   </ng-container>
                    <!-- <app-doughnut
                  class="m-t-23"
                  [colors]="[
                    '#544F4F',
                    '#FFAA00',
                    '#00B458',
                    '#FF1F26',
                    '#8C0000'
                  ]"
                  [customLabels]="['Not Started', 'Ongoing', 'Completed', 'Delayed', 'Terminated']"
                  [series]="[44, 55, 13, 43, 22]"

                ></app-doughnut> -->
                  </div>
                </div>
              </div>
            </div>
            <div class="list-view" *ngIf="val == 'listView'">
              <div class="quarterly-outcome-list">
                <p-scrollPanel
                  *ngIf="!isOutcomeListLoaded; else ShimmerEffect"
                  [style]="{ width: '100%', height: 'calc(100vh - 33vh)' }"
                >
                  <!-- <app-loader *ngIf="isLoading"></app-loader> -->
                  <ng-container
                    *ngIf="outcomesList?.length; else noDataFound"
                  ></ng-container>
                  <app-virtual-scroll
                    class="w-full"
                    [data]="outcomListData"
                    [apiUrl]="outcomeListUrl"
                    (loadedData)="onDataLoaded($event)"
                  >
                    <app-quarterly-outcome-list
                      *ngFor="let outcomes of outcomesList"
                      [outcomesData]="outcomes"
                    ></app-quarterly-outcome-list>
                  </app-virtual-scroll>
                </p-scrollPanel>
              </div>
            </div>
          </div>
          <div *ngIf="value == 'annual'">
            <div class="graph-view" *ngIf="val == 'chartView'">
              <div class="dis-flex">
                <div class="graph-card">
                  <h3
                    class="graph-title text-90 font-medium border-bottom-20 p-b-8" ngbTooltip="Medium Term Outcomes"
                  >
                  MTO (Theme Wise)
                  </h3>
                  <div class="graph-wrapper">
                    <!-- <div *ngIf="isThemeLoading">Loading status wise data...</div> -->
                    <ng-container *ngIf="!isThemeLoading && hasOutcomesThemes;else noDataFound">
                    <app-bar
                      *ngIf="!QThemeWise"
                      class="w-full"
                      [barType]="true"
                      [xAxisLabels]="themesColor"
                      [themeVal]="themes"
                      [colors]="barColor"
                    ></app-bar>
                  </ng-container>
                  </div>
                </div>
                <div class="graph-card">
                  <h3
                    class="graph-title text-90 font-medium border-bottom-20 p-b-8" ngbTooltip="Medium Term Outcomes"
                  >
                    MTO (Status Wise)
                  </h3>
                  <div class="graph-wrapper">
                    <!-- <div *ngIf="QStatusWiseA">Loading status wise data...</div> -->
                    <ng-container *ngIf="!NoCountShow;else noDataFound">
                    <app-doughnut
                      *ngIf="!QStatusWiseA"
                      class="m-t-23"
                      [colors]="[
                        '#544F4F',
                        '#FFAA00',
                        '#00B458',
                        '#FF1F26',
                        '#8C0000'
                      ]"
                      [customLabels]="[
                        'Not Started',
                        'Ongoing',
                        'Completed',
                        'Delayed',
                        'Terminated'
                      ]"
                      [series]="graphstatus"
                    ></app-doughnut>
                  </ng-container>
                  </div>
                </div>
              </div>
            </div>
            <div class="list-view p-t-8 p-b-8" *ngIf="val == 'listView'">
              <p-scrollPanel
                *ngIf="!isOutcomeListLoaded; else ShimmerEffect"
                [style]="{ width: '100%', height: 'calc(100vh - 35vh)' }"
              >
                <!-- <app-loader *ngIf="isLoading"></app-loader> -->
                <ng-container *ngIf="outcomesList?.length; else noDataFound">
                  <app-virtual-scroll
                    class="w-full"
                    [data]="outcomListData"
                    [apiUrl]="outcomeListUrl"
                    (loadedData)="onDataLoaded($event)"
                  >
                    <app-annual-outcome-list
                      *ngFor="let outcomes of outcomesList"
                      [outcomesData]="outcomes"
                      [isAffiliate]="this.selectedRole=='affiliate' ? true : false"
                    ></app-annual-outcome-list>
                  </app-virtual-scroll>
                </ng-container>
              </p-scrollPanel>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<ng-template #ShimmerEffect>
  <app-shimmer-list [count]="5"></app-shimmer-list>
</ng-template>

<ng-template #noDataFound>
  <app-no-data-found></app-no-data-found>
</ng-template>
